import s from './s.module.scss'

const VestedSkeleton = () => (
  <div className={s.vestedBlock}>
    <div className={s.skeletonHeader} />
    <div className={s.skeletonDescription} />
  </div>
)

const ClaimSkeleton = () => (
  <div className={s.claim}>
    <span className={s.claimTitle}>Left to claim</span>
    <div className={s.lsd} />
    <div className={s.claimButton} />
  </div>
)

const AlreadyClaimedSkeleton = () => (
  <div className={s.claimedBlock}>
    <div className={s.claimedDescription} />
  </div>
)

export { AlreadyClaimedSkeleton, ClaimSkeleton, VestedSkeleton }
